'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserLink = exports.styles = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp; // import React, { Component } from 'react'
// import PropTypes from 'prop-types'
// import Link from '../';
// const propTypes = Object.assign({...Link.propTypes}, {
//   username: PropTypes.string.isRequired,
// });
// export default class UserLink extends Link {
//   getUrl(){
//     const {
//       username,
//     } = this.props;
//     return `/profile/${username}/`;
//   }
// }
// import Avatar from '../../Avatar';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _reactRouterDom = require('react-router-dom');

var _styles = require('material-ui/styles');

var _Grid = require('material-ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = exports.styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: "none",
    width: "auto"
  },
  row: {
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: "none"
  },
  avatar: {
    "&.avatar-inline": {
      display: "inline-flex",
      margin: 0
    },
    "&.avatar-size--small": {
      width: 25,
      height: 25,
      lineHeight: 25
    }
  }
};
var UserLink = exports.UserLink = (_temp = _class = function (_Component) {
  _inherits(UserLink, _Component);

  function UserLink() {
    _classCallCheck(this, UserLink);

    return _possibleConstructorReturn(this, (UserLink.__proto__ || Object.getPrototypeOf(UserLink)).apply(this, arguments));
  }

  _createClass(UserLink, [{
    key: 'makeUrl',
    value: function makeUrl(user) {
      var id = user.id;
      return '/users/' + id;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          variant = _props.variant,
          withAvatar = _props.withAvatar,
          classes = _props.classes,
          secondary = _props.secondary,
          showName = _props.showName,
          size = _props.size,
          avatarProps = _props.avatarProps,
          children = _props.children,
          color = _props.color,
          other = _objectWithoutProperties(_props, ['user', 'variant', 'withAvatar', 'classes', 'secondary', 'showName', 'size', 'avatarProps', 'children', 'color']);

      if (!user) {
        return null;
      }

      var _ref = avatarProps || {},
          avatarStyle = _ref.style,
          otherAvatarProps = _objectWithoutProperties(_ref, ['style']);

      var Avatar = this.context.Avatar;
      var id = user.id,
          username = user.username,
          fullname = user.fullname;
      var name = fullname || username;
      var url = this.makeUrl(user);

      var avatarLink = _react2.default.createElement(_reactRouterDom.Link, _extends({
        key: id,
        to: url,
        href: url,
        title: fullname || username
      }, other), _react2.default.createElement(Avatar, _extends({
        user: user,
        className: [classes.avatar, "avatar-inline", 'avatar-size--' + size].join(" "),
        style: _extends({
          marginRight: 5
        }, avatarStyle)
      }, otherAvatarProps)));

      return showName ? _react2.default.createElement(_Grid2.default, {
        container: true,
        className: classes.root
      }, _react2.default.createElement(_Grid2.default, {
        item: true
      }, withAvatar && avatarLink || null), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: true
      }, _react2.default.createElement(_reactRouterDom.Link, _extends({
        key: id,
        to: url,
        href: url,
        style: {
          marginLeft: 5
        }
      }, other), children ? children : variant !== undefined ? _react2.default.createElement(_Typography2.default, {
        variant: variant,
        color: color
      }, name, this.props.position ? _react2.default.createElement('span', {
        style: {
          fontSize: '70%',
          fontStyle: 'italic'
        }
      }, ' - ', this.props.position) : null) : name), secondary)) : avatarLink || null;
    }
  }]);

  return UserLink;
}(_react.Component), _class.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  withAvatar: _propTypes2.default.bool.isRequired,
  showName: _propTypes2.default.bool.isRequired,
  size: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.string,
  avatarProps: _propTypes2.default.object
}, _class.defaultProps = {
  withAvatar: true,
  showName: true,
  size: "normal",
  color: "inherit"
}, _class.contextType = _context2.default, _temp);
exports.default = (0, _styles.withStyles)(styles)(function (props) {
  return _react2.default.createElement(UserLink, props);
});